import React from 'react';

/** Bifold wallet icon (not briefcase or coin). */
export default function WalletIcon({ size = 16, color = 'currentColor', style, className }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
      style={style}
      className={className}
    >
      <path
        d="M4 8h16a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-1"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 8V7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v1"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="17" cy="14" r="1.5" fill={color} />
    </svg>
  );
}
